import { render, staticRenderFns } from "./buttons.vue?vue&type=template&id=7858c26e&"
import script from "./buttons.vue?vue&type=script&lang=ts&"
export * from "./buttons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports